<template>
  <div class="table-responsive">
    <table class="table table-striped table-hover">
      <thead class="table-head-dark">
        <tr>
          <th scope="col" class="text-sm" @click="this.sortColumn('name', supplyType)">
            Nombre
            <i v-if="this.selectedColumn === 'name'" :class="this.sortDirection ? 'icon-angle-down' : 'icon-angle-up'"></i>
          </th>
          <th scope="col" class="text-sm">Proveedor</th>
          <th scope="col" class="text-sm" @click="this.sortColumn('format', supplyType)">
            Formato
            <i v-if="this.selectedColumn === 'format'" :class="this.sortDirection ? 'icon-angle-down' : 'icon-angle-up'"></i>
          </th>
          <th scope="col" class="text-sm">Descripción</th>
          <th scope="col" class="text-sm">Cant. total por unidad</th>
          <th scope="col" class="text-sm">Precio por formato</th>
          <th scope="col" class="text-sm">Precio por presentación</th>
          <th scope="col" class="text-sm">Estatus</th>
          <th scope="col" class="text-align text-sm">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr scope="row" v-if="this.loading" style="width: 50vw; height: 2rem">
          <td colspan="9">
            <div class="d-flex justify-content-center">
              <div class="spinner-border" role="status">
                <span class="sr-only"></span>
              </div>
            </div>
          </td>
        </tr>
        <tr scope="row" v-else-if="!this.loading && supplyArray.length === 0" style="width: 50vw; height: 2rem">
          <td colspan="9" class="text-center">
            <n-p>No se encontraron resultados...</n-p>
          </td>
        </tr>
        <tr v-else-if="!this.loading && supplyArray.length > 0" v-for="(supply, index) in supplyArray" :key="index">
          <td scope="row" class="align-middle text-sm">{{ supply.name }}</td>
          <td scope="row" class="align-middle text-sm">{{ supply.provider.name }}</td>
          <td scope="row" class="align-middle text-sm" style="text-transform: capitalize">{{ supply.format || "No especificado" }}</td>
          <td scope="row" class="align-middle text-sm">{{ supply.presentation.description || "No especificado" }}</td>
          <td scope="row" class="align-middle text-sm">{{ supply.presentation.totalAmountInFormatUnit || "No especificado" }}</td>
          <td scope="row" class="align-middle text-sm">{{ supply.price.perFormat.toFixed(2) || "No especificado" }}</td>
          <td scope="row" class="align-middle text-sm">{{ supply?.price?.perPresentation?.toFixed(2) || "No especificado" }}</td>
          <td scope="row" class="align-middle text-sm">{{ supply.isAvailable ? "Disponible" : "No disponible" }}</td>
          <td scope="row" class="align-middle">
            <n-tooltip trigger="hover" v-if="supply.type === 'gasoil'">
              <template #trigger>
                    <i @click="setGasoil({gasoilId: supply._id})" class="icon-check-sign" style="padding-right: 12px" />
              </template>
              Usar éste gasoil para la creación de planes
            </n-tooltip>
            <n-tooltip trigger="hover">
              <template #trigger>
                <router-link :to="{ name: this.editRoute, params: { id: supply._id } }" style="text-decoration: none; color: inherit">
                  <i class="icon-edit" style="padding-right: 12px" />
                </router-link>
              </template>
              Editar
            </n-tooltip>
            <n-tooltip trigger="hover">
              <template #trigger>
                <i class="icon-copy" style="padding-right: 12px; cursor: pointer" @click="initialyzeCloneSupply(supply)" />
              </template>
              Clonar
            </n-tooltip>
            <n-tooltip trigger="hover">
              <template #trigger>
                <span @click="handleConfirm(supply)" style="cursor: pointer; padding-bottom: 4px; padding-right: 12px">
                  <i class="icon-trash" />
                </span>
              </template>
              Eliminar
            </n-tooltip>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapActions, mapState } from "pinia";
import supplyStore from "../../store/supply";
import configurationStore from '../../store/configuration';
import { useMessage, useDialog } from "naive-ui";
export default {
  data() {
    return {
      dialog: useDialog(),
      message: useMessage(),
      selectedColumn: "",
    };
  },
  props: {
    supplyType: String,
    supplyArray: Array,
    editRoute: String,
  },
  computed: {
    ...mapState(supplyStore, ["sortDirection", "loading"]),
  },
  methods: {
    ...mapActions(supplyStore, ["sortSupplies", "removeSupply", "selectSupplyToBeCloned"]),
    ...mapActions(configurationStore, ['setGasoil']),
    initialyzeCloneSupply(supply) {
      this.$emit("initialyzeCloneFunction", supply);
    },
    sortColumn(key, type) {
      this.sortSupplies(key, type);
      this.selectedColumn = key;
    },
    handleConfirm(supply) {
      this.dialog.warning({
        title: "Confirmar",
        content: "Esta seguro que desea eliminar el suministro?",
        positiveText: "ACEPTAR",
        negativeText: "CANCELAR",
        onPositiveClick: async () => {
          await this.removeSupply(supply._id, this.supplyType);
          this.$emit("supplyRemoved");
        },
        onNegativeClick: () => {
          this.message.info("Acción cancelada");
        },
      });
    },
  },
};
</script>
